var render = function () {
  var _vm$milestoneInfo, _vm$milestoneInfo$pro, _vm$milestoneInfo$pro2, _vm$milestoneInfo$pro3, _vm$milestoneInfo$pro4, _vm$milestoneInfo2, _vm$milestoneInfo2$pr, _vm$milestoneInfo2$pr2, _vm$milestoneInfo2$pr3, _vm$milestoneInfo2$pr4, _vm$milestoneInfo3, _vm$milestoneInfo3$pr, _vm$milestoneInfo3$pr2, _vm$milestoneInfo3$pr3, _vm$milestoneInfo3$pr4, _vm$milestoneInfo4, _vm$milestoneInfo4$pr, _vm$milestoneInfo4$pr2, _vm$milestoneInfo4$pr3, _vm$milestoneInfo4$pr4, _vm$milestoneInfo5, _vm$milestoneInfo5$pr, _vm$milestoneInfo5$pr2, _vm$milestoneInfo5$pr3, _vm$milestoneInfo5$pr4, _vm$milestoneInfo6, _vm$milestoneInfo6$pr, _vm$milestoneInfo6$pr2, _vm$milestoneInfo6$pr3, _vm$milestoneInfo6$pr4, _vm$milestoneInfo7, _vm$milestoneInfo7$pr, _vm$milestoneInfo7$pr2, _vm$milestoneInfo7$pr3, _vm$milestoneInfo7$pr4, _vm$milestoneInfo8, _vm$milestoneInfo8$pr, _vm$milestoneInfo8$pr2, _vm$milestoneInfo8$pr3, _vm$milestoneInfo8$pr4, _vm$milestoneInfo9, _vm$milestoneInfo9$pr, _vm$milestoneInfo9$pr2, _vm$milestoneInfo9$pr3, _vm$milestoneInfo9$pr4, _vm$invoiceInfo3, _vm$grandTotalAmount, _vm$invoiceInfo4, _vm$invoiceInfo5, _vm$invoiceInfo6, _vm$grandTotalAmount2, _vm$invoiceInfo7, _vm$invoiceInfo8, _vm$accountInfo, _vm$accountInfo2, _vm$accountInfo3, _vm$accountInfo4, _vm$accountInfo5, _vm$accountInfo6, _vm$accountInfo7, _vm$accountInfo7$coun, _vm$accountInfo7$coun2, _vm$accountInfo8, _vm$accountInfo9, _vm$accountInfo10, _vm$accountInfo11, _vm$milestoneInfo10, _vm$milestoneInfo11, _vm$milestoneInfo12, _vm$milestoneInfo13, _vm$milestoneInfo14, _vm$milestoneInfo15, _vm$milestoneInfo15$p, _vm$milestoneInfo15$p2, _vm$milestoneInfo15$p3, _vm$milestoneInfo15$p4, _vm$milestoneInfo16, _vm$milestoneInfo16$p, _vm$milestoneInfo16$p2, _vm$milestoneInfo16$p3, _vm$milestoneInfo16$p4, _vm$milestoneInfo17, _vm$milestoneInfo17$p, _vm$milestoneInfo17$p2, _vm$milestoneInfo17$p3, _vm$milestoneInfo17$p4, _vm$milestoneInfo18, _vm$milestoneInfo18$p, _vm$milestoneInfo18$p2, _vm$milestoneInfo18$p3, _vm$milestoneInfo18$p4, _vm$milestoneInfo19, _vm$milestoneInfo19$p, _vm$milestoneInfo19$p2, _vm$milestoneInfo19$p3, _vm$milestoneInfo19$p4, _vm$milestoneInfo20, _vm$milestoneInfo20$p, _vm$milestoneInfo20$p2, _vm$milestoneInfo20$p3, _vm$milestoneInfo20$p4, _vm$milestoneInfo21, _vm$milestoneInfo21$p, _vm$milestoneInfo21$p2, _vm$milestoneInfo21$p3, _vm$milestoneInfo21$p4, _vm$milestoneInfo22, _vm$milestoneInfo22$p, _vm$milestoneInfo22$p2, _vm$milestoneInfo22$p3, _vm$milestoneInfo22$p4, _vm$milestoneInfo23, _vm$milestoneInfo23$p, _vm$milestoneInfo23$p2, _vm$milestoneInfo23$p3, _vm$milestoneInfo23$p4, _vm$grandTotalAmount3, _vm$grandTotalAmount4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "invoice-add-wrapper"
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.invoiceData === undefined
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_vm._v("Error fetching invoice data")]), _c('div', {
    staticClass: "alert-body"
  }, [_vm._v(" No invoice found with this invoice id. Check "), _c('b-link', {
    staticClass: "alert-link",
    attrs: {
      "to": {
        name: 'apps-invoice-list'
      }
    }
  }, [_vm._v(" Invoice List ")]), _vm._v(" for other invoices. ")], 1)]), _vm.invoiceData ? _c('b-row', {
    staticClass: "invoice-add"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "xl": "9",
      "md": "8"
    }
  }, [_c('validation-observer', {
    ref: "milestoneInvoiceValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.milestoneInvoiceValidationForm($event);
      }
    }
  }, [_c('b-card', {
    staticClass: "invoice-preview-card",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-body', {
    staticClass: "invoice-padding pb-0"
  }, [_vm.showLogo ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "logo-wrapper"
  }, [_vm.companyLogo ? [_c('img', {
    staticClass: "mb-3",
    attrs: {
      "src": _vm.companyLogo,
      "alt": "Company Logo",
      "height": "160"
    }
  })] : _vm._e()], 2)]) : _vm._e(), _c('b-row', {
    staticClass: "invoice-spacing"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('h1', {
    staticClass: "mb-2"
  }, [_vm._v("INVOICE")]), (_vm$milestoneInfo = _vm.milestoneInfo) !== null && _vm$milestoneInfo !== void 0 && (_vm$milestoneInfo$pro = _vm$milestoneInfo.project) !== null && _vm$milestoneInfo$pro !== void 0 && (_vm$milestoneInfo$pro2 = _vm$milestoneInfo$pro.data) !== null && _vm$milestoneInfo$pro2 !== void 0 && (_vm$milestoneInfo$pro3 = _vm$milestoneInfo$pro2.lead) !== null && _vm$milestoneInfo$pro3 !== void 0 && (_vm$milestoneInfo$pro4 = _vm$milestoneInfo$pro3.data) !== null && _vm$milestoneInfo$pro4 !== void 0 && _vm$milestoneInfo$pro4.billing_address ? [_c('div', {
    attrs: {
      "id": "quill-content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.milestoneInfo.project.data.lead.data.billing_address)
    }
  })] : [_vm.showContactPerson && (_vm$milestoneInfo2 = _vm.milestoneInfo) !== null && _vm$milestoneInfo2 !== void 0 && (_vm$milestoneInfo2$pr = _vm$milestoneInfo2.project) !== null && _vm$milestoneInfo2$pr !== void 0 && (_vm$milestoneInfo2$pr2 = _vm$milestoneInfo2$pr.data) !== null && _vm$milestoneInfo2$pr2 !== void 0 && (_vm$milestoneInfo2$pr3 = _vm$milestoneInfo2$pr2.lead) !== null && _vm$milestoneInfo2$pr3 !== void 0 && (_vm$milestoneInfo2$pr4 = _vm$milestoneInfo2$pr3.data) !== null && _vm$milestoneInfo2$pr4 !== void 0 && _vm$milestoneInfo2$pr4.key_contact_person ? _c('div', [_vm._v(" " + _vm._s((_vm$milestoneInfo3 = _vm.milestoneInfo) === null || _vm$milestoneInfo3 === void 0 ? void 0 : (_vm$milestoneInfo3$pr = _vm$milestoneInfo3.project) === null || _vm$milestoneInfo3$pr === void 0 ? void 0 : (_vm$milestoneInfo3$pr2 = _vm$milestoneInfo3$pr.data) === null || _vm$milestoneInfo3$pr2 === void 0 ? void 0 : (_vm$milestoneInfo3$pr3 = _vm$milestoneInfo3$pr2.lead) === null || _vm$milestoneInfo3$pr3 === void 0 ? void 0 : (_vm$milestoneInfo3$pr4 = _vm$milestoneInfo3$pr3.data) === null || _vm$milestoneInfo3$pr4 === void 0 ? void 0 : _vm$milestoneInfo3$pr4.key_contact_person) + " ")]) : _vm._e(), _vm.showAddress && (_vm$milestoneInfo4 = _vm.milestoneInfo) !== null && _vm$milestoneInfo4 !== void 0 && (_vm$milestoneInfo4$pr = _vm$milestoneInfo4.project) !== null && _vm$milestoneInfo4$pr !== void 0 && (_vm$milestoneInfo4$pr2 = _vm$milestoneInfo4$pr.data) !== null && _vm$milestoneInfo4$pr2 !== void 0 && (_vm$milestoneInfo4$pr3 = _vm$milestoneInfo4$pr2.lead) !== null && _vm$milestoneInfo4$pr3 !== void 0 && (_vm$milestoneInfo4$pr4 = _vm$milestoneInfo4$pr3.data) !== null && _vm$milestoneInfo4$pr4 !== void 0 && _vm$milestoneInfo4$pr4.address ? _c('div', [_vm._v(" " + _vm._s((_vm$milestoneInfo5 = _vm.milestoneInfo) === null || _vm$milestoneInfo5 === void 0 ? void 0 : (_vm$milestoneInfo5$pr = _vm$milestoneInfo5.project) === null || _vm$milestoneInfo5$pr === void 0 ? void 0 : (_vm$milestoneInfo5$pr2 = _vm$milestoneInfo5$pr.data) === null || _vm$milestoneInfo5$pr2 === void 0 ? void 0 : (_vm$milestoneInfo5$pr3 = _vm$milestoneInfo5$pr2.lead) === null || _vm$milestoneInfo5$pr3 === void 0 ? void 0 : (_vm$milestoneInfo5$pr4 = _vm$milestoneInfo5$pr3.data) === null || _vm$milestoneInfo5$pr4 === void 0 ? void 0 : _vm$milestoneInfo5$pr4.address) + " ")]) : _vm._e(), _vm.showEmail && (_vm$milestoneInfo6 = _vm.milestoneInfo) !== null && _vm$milestoneInfo6 !== void 0 && (_vm$milestoneInfo6$pr = _vm$milestoneInfo6.project) !== null && _vm$milestoneInfo6$pr !== void 0 && (_vm$milestoneInfo6$pr2 = _vm$milestoneInfo6$pr.data) !== null && _vm$milestoneInfo6$pr2 !== void 0 && (_vm$milestoneInfo6$pr3 = _vm$milestoneInfo6$pr2.lead) !== null && _vm$milestoneInfo6$pr3 !== void 0 && (_vm$milestoneInfo6$pr4 = _vm$milestoneInfo6$pr3.data) !== null && _vm$milestoneInfo6$pr4 !== void 0 && _vm$milestoneInfo6$pr4.email ? _c('div', [_vm._v(" " + _vm._s((_vm$milestoneInfo7 = _vm.milestoneInfo) === null || _vm$milestoneInfo7 === void 0 ? void 0 : (_vm$milestoneInfo7$pr = _vm$milestoneInfo7.project) === null || _vm$milestoneInfo7$pr === void 0 ? void 0 : (_vm$milestoneInfo7$pr2 = _vm$milestoneInfo7$pr.data) === null || _vm$milestoneInfo7$pr2 === void 0 ? void 0 : (_vm$milestoneInfo7$pr3 = _vm$milestoneInfo7$pr2.lead) === null || _vm$milestoneInfo7$pr3 === void 0 ? void 0 : (_vm$milestoneInfo7$pr4 = _vm$milestoneInfo7$pr3.data) === null || _vm$milestoneInfo7$pr4 === void 0 ? void 0 : _vm$milestoneInfo7$pr4.email) + " ")]) : _vm._e(), _vm.showMobile && (_vm$milestoneInfo8 = _vm.milestoneInfo) !== null && _vm$milestoneInfo8 !== void 0 && (_vm$milestoneInfo8$pr = _vm$milestoneInfo8.project) !== null && _vm$milestoneInfo8$pr !== void 0 && (_vm$milestoneInfo8$pr2 = _vm$milestoneInfo8$pr.data) !== null && _vm$milestoneInfo8$pr2 !== void 0 && (_vm$milestoneInfo8$pr3 = _vm$milestoneInfo8$pr2.lead) !== null && _vm$milestoneInfo8$pr3 !== void 0 && (_vm$milestoneInfo8$pr4 = _vm$milestoneInfo8$pr3.data) !== null && _vm$milestoneInfo8$pr4 !== void 0 && _vm$milestoneInfo8$pr4.mobile ? _c('div', [_vm._v(" " + _vm._s((_vm$milestoneInfo9 = _vm.milestoneInfo) === null || _vm$milestoneInfo9 === void 0 ? void 0 : (_vm$milestoneInfo9$pr = _vm$milestoneInfo9.project) === null || _vm$milestoneInfo9$pr === void 0 ? void 0 : (_vm$milestoneInfo9$pr2 = _vm$milestoneInfo9$pr.data) === null || _vm$milestoneInfo9$pr2 === void 0 ? void 0 : (_vm$milestoneInfo9$pr3 = _vm$milestoneInfo9$pr2.lead) === null || _vm$milestoneInfo9$pr3 === void 0 ? void 0 : (_vm$milestoneInfo9$pr4 = _vm$milestoneInfo9$pr3.data) === null || _vm$milestoneInfo9$pr4 === void 0 ? void 0 : _vm$milestoneInfo9$pr4.mobile) + " ")]) : _vm._e()]], 2), _c('b-col', {
    staticClass: "text-md-left",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('h6', {
    staticClass: "invoice-title"
  }, [_vm._v("Invoice No.")]), _c('b-input-group', {
    staticClass: "input-group-merge invoice-edit-input-group disabled"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "HashIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "id": "invoice-data-id",
      "disabled": ""
    },
    model: {
      value: _vm.invoiceId,
      callback: function callback($$v) {
        _vm.invoiceId = $$v;
      },
      expression: "invoiceId"
    }
  })], 1)], 1), _c('div', {
    staticClass: "mb-3"
  }, [_c('h6', {
    staticClass: "invoice-title"
  }, [_vm._v("Invoice Date")]), _c('ValidationProvider', {
    attrs: {
      "name": "issue date",
      "vid": "issue_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _vm$invoiceInfo;
        var errors = _ref.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control invoice-edit-input",
          attrs: {
            "disabled": ((_vm$invoiceInfo = _vm.invoiceInfo) === null || _vm$invoiceInfo === void 0 ? void 0 : _vm$invoiceInfo.status) !== 'due'
          },
          model: {
            value: _vm.issueDate,
            callback: function callback($$v) {
              _vm.issueDate = $$v;
            },
            expression: "issueDate"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 230703191)
  })], 1), _c('div', {
    staticClass: "mb-3"
  }, [_c('h6', {
    staticClass: "invoice-title"
  }, [_vm._v("Due Date")]), _c('ValidationProvider', {
    attrs: {
      "name": "due date",
      "vid": "due_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var _vm$invoiceInfo2;
        var errors = _ref2.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control invoice-edit-input",
          attrs: {
            "disabled": ((_vm$invoiceInfo2 = _vm.invoiceInfo) === null || _vm$invoiceInfo2 === void 0 ? void 0 : _vm$invoiceInfo2.status) !== 'due'
          },
          model: {
            value: _vm.dueDate,
            callback: function callback($$v) {
              _vm.dueDate = $$v;
            },
            expression: "dueDate"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 1424881082)
  })], 1)]), _c('b-col', {
    staticClass: "text-center text-md-left",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('h6', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.companyName))]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(this.officeAddress)
    }
  }), _c('p', {
    staticClass: "card-text mb-0"
  }, [_vm._v("Phone: " + _vm._s(this.officeMobile))]), _c('p', {
    staticClass: "card-text mb-0"
  }, [_vm._v("Email: " + _vm._s(this.officeEmail))])])], 1)], 1), ((_vm$invoiceInfo3 = _vm.invoiceInfo) === null || _vm$invoiceInfo3 === void 0 ? void 0 : _vm$invoiceInfo3.status) !== 'due' ? [_c('b-card-body', {
    staticClass: "invoice-padding form-item-section"
  }, [_c('div', {
    ref: "form",
    staticClass: "repeater-form"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', {
    staticClass: "table-light"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("SL No.")]), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Description")]), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Quantity")]), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(" Unit Price (" + _vm._s(_vm.currency) + ") ")]), _c('th', {
    staticClass: "text-end",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(" Total (" + _vm._s(_vm.currency) + ") ")])])]), _c('tbody', [_vm._l(_vm.invoiceData.items, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _c('td', {
      staticStyle: {
        "width": "50%"
      }
    }, [item.itemTitle ? _c('div', [_c('div', {
      staticClass: "fw-bold"
    }, [_vm._v(_vm._s(item.itemTitle))]), _c('p', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "text-truncate",
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "title": item.description
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(item.description))])])]) : _vm._e()]), _c('td', {
      staticStyle: {
        "width": "5%",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.qty || 0))]), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.cost || 0))]), _c('td', {
      staticClass: "text-end",
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(" " + _vm._s(item.cost * item.qty || 0) + " ")])]);
  }), _c('tr', {
    staticClass: "border-0"
  }, [_c('td', {
    staticClass: "text-right border-0",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Subtotal ")]), _c('td', {
    staticClass: "text-end"
  }, [_c('strong', [_vm._v(_vm._s(_vm.subTotalAmount))])])]), _c('tr', [_c('td', {
    staticClass: "text-right border-0",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("VAT")]), _c('td', {
    staticClass: "text-end"
  }, [_c('strong', [_vm._v(_vm._s(_vm.vatAmount))])])]), _vm.showTax ? _c('tr', [_c('td', {
    staticClass: "text-right border-0",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("TAX")]), _c('td', {
    staticClass: "text-end"
  }, [_c('strong', [_vm._v(_vm._s(_vm.taxAmount))])])]) : _vm._e(), _c('tr', [_c('td', {
    staticClass: "text-right border-0",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Grand Total ")]), _c('td', {
    staticClass: "text-end text-danger"
  }, [_c('strong', [_vm._v(_vm._s((_vm$grandTotalAmount = _vm.grandTotalAmount) !== null && _vm$grandTotalAmount !== void 0 ? _vm$grandTotalAmount : 0))])])])], 2)])])])])] : _vm._e(), ((_vm$invoiceInfo4 = _vm.invoiceInfo) === null || _vm$invoiceInfo4 === void 0 ? void 0 : _vm$invoiceInfo4.status) === 'due' ? [_c('b-card-body', {
    staticClass: "invoice-padding form-item-section"
  }, [_c('div', {
    ref: "form",
    staticClass: "repeater-form",
    style: {
      height: _vm.trHeight
    }
  }, _vm._l(_vm.invoiceData.items, function (item, index) {
    return _c('b-row', {
      key: index,
      ref: "row",
      refInFor: true,
      staticClass: "pb-2"
    }, [_c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "d-none d-lg-flex"
    }, [_c('b-row', {
      staticClass: "flex-grow-1 px-1"
    }, [_c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "5"
      }
    }, [_vm._v(" Description ")]), _c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "3"
      }
    }, [_vm._v(" Unit Price ")]), _c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "2"
      }
    }, [_vm._v(" Quantity ")]), _c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "2"
      }
    }, [_vm._v(" Total ")])], 1), _c('div', {
      staticClass: "form-item-action-col"
    })], 1), _c('div', {
      staticClass: "d-flex border rounded"
    }, [_c('b-row', {
      staticClass: "flex-grow-1 p-2"
    }, [_c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "5"
      }
    }, [_c('b-form-group', [_c('ValidationProvider', {
      attrs: {
        "name": "item",
        "vid": "item",
        "rules": "required"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref3) {
          var errors = _ref3.errors;
          return [_c('b-form-input', {
            attrs: {
              "type": "text"
            },
            model: {
              value: item.itemTitle,
              callback: function callback($$v) {
                _vm.$set(item, "itemTitle", $$v);
              },
              expression: "item.itemTitle"
            }
          }), _c('small', {
            staticClass: "text-danger"
          }, [_vm._v(_vm._s(errors[0]))])];
        }
      }], null, true)
    })], 1)], 1), _c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "3"
      }
    }, [_c('b-form-group', [_c('ValidationProvider', {
      attrs: {
        "name": "amount",
        "vid": "amount",
        "rules": "required|min_value:0"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref4) {
          var errors = _ref4.errors;
          return [_c('b-form-input', {
            attrs: {
              "type": "number"
            },
            model: {
              value: item.cost,
              callback: function callback($$v) {
                _vm.$set(item, "cost", $$v);
              },
              expression: "item.cost"
            }
          }), _c('small', {
            staticClass: "text-danger"
          }, [_vm._v(_vm._s(errors[0]))])];
        }
      }], null, true)
    })], 1)], 1), _c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "2"
      }
    }, [_c('b-form-group', [_c('ValidationProvider', {
      attrs: {
        "name": "quantity",
        "vid": "quantity",
        "rules": "required|min_value:1"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref5) {
          var errors = _ref5.errors;
          return [_c('b-form-input', {
            attrs: {
              "type": "number"
            },
            model: {
              value: item.qty,
              callback: function callback($$v) {
                _vm.$set(item, "qty", $$v);
              },
              expression: "item.qty"
            }
          }), _c('small', {
            staticClass: "text-danger"
          }, [_vm._v(_vm._s(errors[0]))])];
        }
      }], null, true)
    })], 1)], 1), _c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "2"
      }
    }, [_c('label', {
      staticClass: "d-inline d-lg-none"
    }, [_vm._v("Price")]), _c('p', {
      staticClass: "mb-1"
    }, [_vm._v(" " + _vm._s(item.cost * item.qty) + " " + _vm._s(_vm.currency) + " ")])]), _c('b-col', {
      attrs: {
        "cols": "12",
        "lg": "5"
      }
    }, [_c('b-form-group', [_c('ValidationProvider', {
      attrs: {
        "name": "description",
        "vid": "description"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref6) {
          var errors = _ref6.errors;
          return [_c('b-form-textarea', {
            staticClass: "mb-lg-0",
            model: {
              value: item.description,
              callback: function callback($$v) {
                _vm.$set(item, "description", $$v);
              },
              expression: "item.description"
            }
          }), _c('small', {
            staticClass: "text-danger"
          }, [_vm._v(_vm._s(errors[0]))])];
        }
      }], null, true)
    })], 1), _c('label', {
      staticClass: "d-inline d-lg-none"
    }, [_vm._v("Description")])], 1)], 1), _c('div', {
      staticClass: "d-flex flex-column justify-content-between border-left py-50 px-25"
    }, [_c('feather-icon', {
      staticClass: "cursor-pointer",
      attrs: {
        "size": "16",
        "icon": "XIcon"
      },
      on: {
        "click": function click($event) {
          _vm.invoiceData.items.length > 1 ? _vm.removeItem(index) : null;
        }
      }
    })], 1)], 1)])], 1);
  }), 1), ((_vm$invoiceInfo5 = _vm.invoiceInfo) === null || _vm$invoiceInfo5 === void 0 ? void 0 : _vm$invoiceInfo5.status) == 'due' ? [_c('div', {
    staticClass: "mt-1"
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.addNewItemInItemForm
    }
  }, [_vm._v(" Add Item ")]), _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "primary"
    }
  }, [_vm._v(" Update ")])], 1)] : _vm._e()], 2), _c('b-card-body', {
    staticClass: "invoice-padding pb-0"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mt-md-0 mt-3 d-flex align-items-center",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "2",
      "order-md": "1"
    }
  }), _c('b-col', {
    staticClass: "mt-md-6 d-flex justify-content-end",
    attrs: {
      "cols": "12",
      "md": "6",
      "order": "1",
      "order-md": "2"
    }
  }, [_c('div', {
    staticClass: "invoice-total-wrapper custom-width"
  }, [_c('div', {
    staticClass: "invoice-total-item"
  }, [_c('p', {
    staticClass: "invoice-total-title"
  }, [_vm._v("Sub Total:")]), _c('p', {
    staticClass: "invoice-total-amount"
  }, [_vm._v(" " + _vm._s(_vm.currency) + " " + _vm._s(_vm.subTotalAmount) + " ")])]), _c('div', {
    staticClass: "invoice-total-item"
  }, [_c('p', {
    staticClass: "invoice-total-title"
  }, [_vm._v("Vat:")]), _c('b-form-group', [_c('ValidationProvider', {
    attrs: {
      "name": "vat amount",
      "vid": "vat_amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var errors = _ref7.errors;
        return [_c('b-input-group', {
          attrs: {
            "append": _vm.currency
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: _vm.vatAmount,
            callback: function callback($$v) {
              _vm.vatAmount = $$v;
            },
            expression: "vatAmount"
          }
        })], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 2069142497)
  })], 1)], 1), _c('div', {
    staticClass: "invoice-total-item"
  }, [_vm.showTax ? _c('p', {
    staticClass: "invoice-total-title"
  }, [_vm._v("Tax:")]) : _vm._e(), _c('b-form-group', [_c('ValidationProvider', {
    attrs: {
      "name": "tax amount",
      "vid": "tax_amount",
      "rules": "required|min_value:0"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var errors = _ref8.errors;
        return [_c('b-input-group', {
          attrs: {
            "append": _vm.currency
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: _vm.taxAmount,
            callback: function callback($$v) {
              _vm.taxAmount = $$v;
            },
            expression: "taxAmount"
          }
        })], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 1088083375)
  })], 1)], 1), _c('hr', {
    staticClass: "my-50"
  }), _c('div', {
    staticClass: "invoice-total-item"
  }, [_c('p', {
    staticClass: "invoice-total-title"
  }, [_vm._v("Grand Total:")]), _c('p', {
    staticClass: "invoice-total-amount"
  }, [_vm._v(" " + _vm._s(_vm.currency) + " " + _vm._s(_vm.grandTotalAmount) + " ")])])])])], 1)], 1), _c('hr', {
    staticClass: "invoice-spacing"
  }), _c('b-card-body', {
    staticClass: "invoice-padding pt-0"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Note: ")]), _c('div', {
    class: {
      fullscreen: _vm.isFullscreen
    }
  }, [_c('quill-editor', {
    staticClass: "custom-quill-editor",
    style: {
      width: '98% !important'
    },
    attrs: {
      "options": _vm.editorOption,
      "id": "payment_details",
      "placeholder": "Payment Details"
    },
    model: {
      value: _vm.remarks,
      callback: function callback($$v) {
        _vm.remarks = $$v;
      },
      expression: "remarks"
    }
  }, [_c('div', {
    attrs: {
      "slot": "toolbar",
      "id": "toolbar"
    },
    slot: "toolbar"
  }, [_c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-bold"
  }, [_vm._v(" Bold ")]), _c('button', {
    staticClass: "ql-italic"
  }, [_vm._v(" Italic ")]), _c('button', {
    staticClass: "ql-underline"
  }, [_vm._v(" Underline ")]), _c('button', {
    staticClass: "ql-strike"
  }, [_vm._v(" Strike ")]), _c('button', {
    staticClass: "ql-blockquote"
  }), _c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "ordered"
    }
  }), _c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "bullet"
    }
  }), _c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "sub"
    }
  }), _c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "super"
    }
  }), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "-1"
    }
  }), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "+1"
    }
  }), _c('button', {
    staticClass: "ql-direction",
    attrs: {
      "value": "rtl"
    }
  }), _c('button', {
    staticClass: "ql-align",
    attrs: {
      "value": ""
    }
  }), _c('button', {
    staticClass: "ql-align",
    attrs: {
      "value": "center"
    }
  }), _c('button', {
    staticClass: "ql-align",
    attrs: {
      "value": "right"
    }
  }), _c('button', {
    staticClass: "ql-align",
    attrs: {
      "value": "justify"
    }
  }), _c('select', {
    staticClass: "ql-color"
  }), _c('select', {
    staticClass: "ql-background"
  }), _c('select', {
    staticClass: "ql-size"
  }, [_c('option', {
    attrs: {
      "value": "small"
    }
  }), _c('option', {
    attrs: {
      "selected": ""
    }
  }), _c('option', {
    attrs: {
      "value": "large"
    }
  }), _c('option', {
    attrs: {
      "value": "huge"
    }
  })]), _c('select', {
    staticClass: "ql-font"
  }), _c('select', {
    staticClass: "ql-header"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" Heading 1 ")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(" Heading 2 ")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v(" Heading 3 ")]), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v(" Heading 4 ")]), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v(" Heading 5 ")]), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v(" Heading 6 ")]), _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("Normal")])]), _c('button', {
    staticClass: "ql-link"
  }), _c('button', {
    staticClass: "fullscreen-btn",
    attrs: {
      "type": "button",
      "title": _vm.isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'
    },
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_vm._v(" 🔳 ")])])])])], 1)])] : _vm._e(), ((_vm$invoiceInfo6 = _vm.invoiceInfo) === null || _vm$invoiceInfo6 === void 0 ? void 0 : _vm$invoiceInfo6.status) !== 'due' ? [_c('b-card-body', {
    staticClass: "invoice-padding pt-0"
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('h4', {
    staticClass: "mb-1",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(" In Words: " + _vm._s(_vm.currency) + " " + _vm._s(_vm.numWords((_vm$grandTotalAmount2 = _vm.grandTotalAmount) !== null && _vm$grandTotalAmount2 !== void 0 ? _vm$grandTotalAmount2 : 0)) + " Only ")]), _vm.remarks ? _c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Note/Terms")]) : _vm._e(), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.remarks)
    }
  })])]), _c('h1', {
    staticClass: "text-center my-5"
  }, [_vm._v("Thank You For Your Business")]), _c('br'), _vm.showLogo ? _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "text-align": "center",
      "display": "block"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%",
      "margin-bottom": "0.5rem"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "flex-wrap": "wrap"
    }
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#145BFF"
    }
  }, [_vm._v("M:")]), _vm._v(" " + _vm._s(_vm.officeMobile) + " ")]), _c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#145BFF"
    }
  }, [_vm._v("E:")]), _vm._v(" " + _vm._s(_vm.officeEmail) + " ")]), _c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#145BFF"
    }
  }, [_vm._v("W:")]), _vm._v(" " + _vm._s(_vm.officeWebsite) + " ")])]), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(" " + _vm._s(_vm.companyName) + ", " + _vm._s(_vm.officeAddress) + " ")])]), _c('div', {
    staticStyle: {
      "background-color": "#145BFF",
      "height": "30px",
      "width": "100%"
    }
  })]) : _vm._e()] : _vm._e()], 2)], 1)], 1)], 1), _c('b-col', {
    staticClass: "invoice-actions",
    attrs: {
      "cols": "12",
      "md": "4",
      "xl": "3"
    }
  }, [_c('h5', {
    staticClass: "mb-30"
  }, [_vm._v("Print Configuration")]), _c('b-card', [_c('b', {
    staticClass: "mb-5"
  }, [_vm._v("Invoice")]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "custom-toggle",
    attrs: {
      "id": "customSwitch1",
      "switch": ""
    },
    model: {
      value: _vm.showLogo,
      callback: function callback($$v) {
        _vm.showLogo = $$v;
      },
      expression: "showLogo"
    }
  }, [_vm._v(" Show Logo ")])], 1), _c('b', {
    staticClass: "mb-5"
  }, [_vm._v("Pricing")]), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "custom-toggle",
    attrs: {
      "id": "customSwitch6",
      "switch": ""
    },
    model: {
      value: _vm.showTax,
      callback: function callback($$v) {
        _vm.showTax = $$v;
      },
      expression: "showTax"
    }
  }, [_vm._v(" Tax ")])], 1), _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(186, 191, 199, 0.15)',
      expression: "'rgba(186, 191, 199, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "mb-75",
    attrs: {
      "variant": "outline-secondary",
      "block": ""
    },
    on: {
      "click": _vm.printInvoice
    }
  }, [_vm._v(" Print ")])], 1), _c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [((_vm$invoiceInfo7 = _vm.invoiceInfo) === null || _vm$invoiceInfo7 === void 0 ? void 0 : _vm$invoiceInfo7.status) !== 'due' ? [_c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("Paid")])] : [_c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Due")])]], 2)], 1), ((_vm$invoiceInfo8 = _vm.invoiceInfo) === null || _vm$invoiceInfo8 === void 0 ? void 0 : _vm$invoiceInfo8.status) == 'due' ? [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.sidebar-invoice-add-payment",
      modifiers: {
        "sidebar-invoice-add-payment": true
      }
    }, {
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "mb-75",
    attrs: {
      "variant": "success",
      "block": ""
    }
  }, [_vm._v(" Collect Payment ")])] : _vm._e(), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    staticClass: "mt-xl-0 mt-2 d-xl-flex d-block",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('h6', {
    staticClass: "mb-30"
  }, [_vm._v("Payment Details:")]), _c('table', [_c('tbody', [_c('div', [_c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Bank Name:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo = _vm.accountInfo) === null || _vm$accountInfo === void 0 ? void 0 : _vm$accountInfo.bank_name))])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Account Name:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo2 = _vm.accountInfo) === null || _vm$accountInfo2 === void 0 ? void 0 : _vm$accountInfo2.name))])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Account Number:")]), _c('td', [_vm._v(" " + _vm._s((_vm$accountInfo3 = _vm.accountInfo) !== null && _vm$accountInfo3 !== void 0 && _vm$accountInfo3.account_number ? (_vm$accountInfo4 = _vm.accountInfo) === null || _vm$accountInfo4 === void 0 ? void 0 : _vm$accountInfo4.account_number : "N/A") + " ")])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Routing Number:")]), _c('td', [_vm._v(" " + _vm._s((_vm$accountInfo5 = _vm.accountInfo) !== null && _vm$accountInfo5 !== void 0 && _vm$accountInfo5.routing_number ? (_vm$accountInfo6 = _vm.accountInfo) === null || _vm$accountInfo6 === void 0 ? void 0 : _vm$accountInfo6.routing_number : "N/A") + " ")])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("Country:")]), _c('td', [_vm._v(_vm._s((_vm$accountInfo7 = _vm.accountInfo) === null || _vm$accountInfo7 === void 0 ? void 0 : (_vm$accountInfo7$coun = _vm$accountInfo7.country) === null || _vm$accountInfo7$coun === void 0 ? void 0 : (_vm$accountInfo7$coun2 = _vm$accountInfo7$coun.data) === null || _vm$accountInfo7$coun2 === void 0 ? void 0 : _vm$accountInfo7$coun2.name))])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("IBAN:")]), _c('td', [_vm._v(" " + _vm._s((_vm$accountInfo8 = _vm.accountInfo) !== null && _vm$accountInfo8 !== void 0 && _vm$accountInfo8.iban_number ? (_vm$accountInfo9 = _vm.accountInfo) === null || _vm$accountInfo9 === void 0 ? void 0 : _vm$accountInfo9.iban_number : "N/A") + " ")])]), _c('tr', [_c('td', {
    staticClass: "pr-1"
  }, [_vm._v("SWIFT code:")]), _c('td', [_vm._v(" " + _vm._s((_vm$accountInfo10 = _vm.accountInfo) !== null && _vm$accountInfo10 !== void 0 && _vm$accountInfo10.swift_code ? (_vm$accountInfo11 = _vm.accountInfo) === null || _vm$accountInfo11 === void 0 ? void 0 : _vm$accountInfo11.swift_code : "N/A") + " ")])])])])])])])], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', {
    staticClass: "mb-lg-1",
    attrs: {
      "cols": "12",
      "xl": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-30"
  }, [_vm._v("Milestone Info:")]), _c('p', {
    staticClass: "card-text mb-25"
  }, [_vm._v("Title: " + _vm._s((_vm$milestoneInfo10 = _vm.milestoneInfo) === null || _vm$milestoneInfo10 === void 0 ? void 0 : _vm$milestoneInfo10.title))]), _c('p', {
    staticClass: "card-text mb-25"
  }, [_vm._v(" Total Amount: " + _vm._s(_vm.currency) + " " + _vm._s((_vm$milestoneInfo11 = _vm.milestoneInfo) === null || _vm$milestoneInfo11 === void 0 ? void 0 : _vm$milestoneInfo11.total_amount) + " ")]), _c('p', {
    staticClass: "card-text mb-25"
  }, [_vm._v(" Total Vat Amount: " + _vm._s(_vm.currency) + " " + _vm._s((_vm$milestoneInfo12 = _vm.milestoneInfo) === null || _vm$milestoneInfo12 === void 0 ? void 0 : _vm$milestoneInfo12.total_vat_amount) + " ")]), _vm.showTax ? _c('p', {
    staticClass: "card-text mb-25"
  }, [_vm._v(" Total Tax Amount: " + _vm._s(_vm.currency) + " " + _vm._s((_vm$milestoneInfo13 = _vm.milestoneInfo) === null || _vm$milestoneInfo13 === void 0 ? void 0 : _vm$milestoneInfo13.total_tax_amount) + " ")]) : _vm._e(), _c('p', {
    staticClass: "card-text mb-25"
  }, [_vm._v(" Grand Total Amount: " + _vm._s(_vm.currency) + " " + _vm._s((_vm$milestoneInfo14 = _vm.milestoneInfo) === null || _vm$milestoneInfo14 === void 0 ? void 0 : _vm$milestoneInfo14.grand_amount) + " ")])])], 1)], 2)], 1)], 1) : _vm._e(), _c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "0",
      "padding": "0",
      "display": "none",
      "position": "relative",
      "font-size": "11px"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_vm.showLogo ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm.companyLogo ? _c('img', {
    attrs: {
      "src": _vm.companyLogo,
      "alt": "Company Logo",
      "height": "160"
    }
  }) : _vm._e()])]) : _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "160px"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "37%",
      "overflow-wrap": "break-word"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "0px",
      "font-size": "28px"
    }
  }, [_vm._v("INVOICE")]), (_vm$milestoneInfo15 = _vm.milestoneInfo) !== null && _vm$milestoneInfo15 !== void 0 && (_vm$milestoneInfo15$p = _vm$milestoneInfo15.project) !== null && _vm$milestoneInfo15$p !== void 0 && (_vm$milestoneInfo15$p2 = _vm$milestoneInfo15$p.data) !== null && _vm$milestoneInfo15$p2 !== void 0 && (_vm$milestoneInfo15$p3 = _vm$milestoneInfo15$p2.lead) !== null && _vm$milestoneInfo15$p3 !== void 0 && (_vm$milestoneInfo15$p4 = _vm$milestoneInfo15$p3.data) !== null && _vm$milestoneInfo15$p4 !== void 0 && _vm$milestoneInfo15$p4.billing_address ? [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.milestoneInfo.project.data.lead.data.billing_address)
    }
  })] : [_vm.showContactPerson && (_vm$milestoneInfo16 = _vm.milestoneInfo) !== null && _vm$milestoneInfo16 !== void 0 && (_vm$milestoneInfo16$p = _vm$milestoneInfo16.project) !== null && _vm$milestoneInfo16$p !== void 0 && (_vm$milestoneInfo16$p2 = _vm$milestoneInfo16$p.data) !== null && _vm$milestoneInfo16$p2 !== void 0 && (_vm$milestoneInfo16$p3 = _vm$milestoneInfo16$p2.lead) !== null && _vm$milestoneInfo16$p3 !== void 0 && (_vm$milestoneInfo16$p4 = _vm$milestoneInfo16$p3.data) !== null && _vm$milestoneInfo16$p4 !== void 0 && _vm$milestoneInfo16$p4.key_contact_person ? _c('div', [_vm._v(" " + _vm._s((_vm$milestoneInfo17 = _vm.milestoneInfo) === null || _vm$milestoneInfo17 === void 0 ? void 0 : (_vm$milestoneInfo17$p = _vm$milestoneInfo17.project) === null || _vm$milestoneInfo17$p === void 0 ? void 0 : (_vm$milestoneInfo17$p2 = _vm$milestoneInfo17$p.data) === null || _vm$milestoneInfo17$p2 === void 0 ? void 0 : (_vm$milestoneInfo17$p3 = _vm$milestoneInfo17$p2.lead) === null || _vm$milestoneInfo17$p3 === void 0 ? void 0 : (_vm$milestoneInfo17$p4 = _vm$milestoneInfo17$p3.data) === null || _vm$milestoneInfo17$p4 === void 0 ? void 0 : _vm$milestoneInfo17$p4.key_contact_person) + " ")]) : _vm._e(), _vm.showAddress && (_vm$milestoneInfo18 = _vm.milestoneInfo) !== null && _vm$milestoneInfo18 !== void 0 && (_vm$milestoneInfo18$p = _vm$milestoneInfo18.project) !== null && _vm$milestoneInfo18$p !== void 0 && (_vm$milestoneInfo18$p2 = _vm$milestoneInfo18$p.data) !== null && _vm$milestoneInfo18$p2 !== void 0 && (_vm$milestoneInfo18$p3 = _vm$milestoneInfo18$p2.lead) !== null && _vm$milestoneInfo18$p3 !== void 0 && (_vm$milestoneInfo18$p4 = _vm$milestoneInfo18$p3.data) !== null && _vm$milestoneInfo18$p4 !== void 0 && _vm$milestoneInfo18$p4.address ? _c('div', [_vm._v(" " + _vm._s((_vm$milestoneInfo19 = _vm.milestoneInfo) === null || _vm$milestoneInfo19 === void 0 ? void 0 : (_vm$milestoneInfo19$p = _vm$milestoneInfo19.project) === null || _vm$milestoneInfo19$p === void 0 ? void 0 : (_vm$milestoneInfo19$p2 = _vm$milestoneInfo19$p.data) === null || _vm$milestoneInfo19$p2 === void 0 ? void 0 : (_vm$milestoneInfo19$p3 = _vm$milestoneInfo19$p2.lead) === null || _vm$milestoneInfo19$p3 === void 0 ? void 0 : (_vm$milestoneInfo19$p4 = _vm$milestoneInfo19$p3.data) === null || _vm$milestoneInfo19$p4 === void 0 ? void 0 : _vm$milestoneInfo19$p4.address) + " ")]) : _vm._e(), _vm.showEmail && (_vm$milestoneInfo20 = _vm.milestoneInfo) !== null && _vm$milestoneInfo20 !== void 0 && (_vm$milestoneInfo20$p = _vm$milestoneInfo20.project) !== null && _vm$milestoneInfo20$p !== void 0 && (_vm$milestoneInfo20$p2 = _vm$milestoneInfo20$p.data) !== null && _vm$milestoneInfo20$p2 !== void 0 && (_vm$milestoneInfo20$p3 = _vm$milestoneInfo20$p2.lead) !== null && _vm$milestoneInfo20$p3 !== void 0 && (_vm$milestoneInfo20$p4 = _vm$milestoneInfo20$p3.data) !== null && _vm$milestoneInfo20$p4 !== void 0 && _vm$milestoneInfo20$p4.email ? _c('div', [_vm._v(" " + _vm._s((_vm$milestoneInfo21 = _vm.milestoneInfo) === null || _vm$milestoneInfo21 === void 0 ? void 0 : (_vm$milestoneInfo21$p = _vm$milestoneInfo21.project) === null || _vm$milestoneInfo21$p === void 0 ? void 0 : (_vm$milestoneInfo21$p2 = _vm$milestoneInfo21$p.data) === null || _vm$milestoneInfo21$p2 === void 0 ? void 0 : (_vm$milestoneInfo21$p3 = _vm$milestoneInfo21$p2.lead) === null || _vm$milestoneInfo21$p3 === void 0 ? void 0 : (_vm$milestoneInfo21$p4 = _vm$milestoneInfo21$p3.data) === null || _vm$milestoneInfo21$p4 === void 0 ? void 0 : _vm$milestoneInfo21$p4.email) + " ")]) : _vm._e(), _vm.showMobile && (_vm$milestoneInfo22 = _vm.milestoneInfo) !== null && _vm$milestoneInfo22 !== void 0 && (_vm$milestoneInfo22$p = _vm$milestoneInfo22.project) !== null && _vm$milestoneInfo22$p !== void 0 && (_vm$milestoneInfo22$p2 = _vm$milestoneInfo22$p.data) !== null && _vm$milestoneInfo22$p2 !== void 0 && (_vm$milestoneInfo22$p3 = _vm$milestoneInfo22$p2.lead) !== null && _vm$milestoneInfo22$p3 !== void 0 && (_vm$milestoneInfo22$p4 = _vm$milestoneInfo22$p3.data) !== null && _vm$milestoneInfo22$p4 !== void 0 && _vm$milestoneInfo22$p4.mobile ? _c('div', [_vm._v(" " + _vm._s((_vm$milestoneInfo23 = _vm.milestoneInfo) === null || _vm$milestoneInfo23 === void 0 ? void 0 : (_vm$milestoneInfo23$p = _vm$milestoneInfo23.project) === null || _vm$milestoneInfo23$p === void 0 ? void 0 : (_vm$milestoneInfo23$p2 = _vm$milestoneInfo23$p.data) === null || _vm$milestoneInfo23$p2 === void 0 ? void 0 : (_vm$milestoneInfo23$p3 = _vm$milestoneInfo23$p2.lead) === null || _vm$milestoneInfo23$p3 === void 0 ? void 0 : (_vm$milestoneInfo23$p4 = _vm$milestoneInfo23$p3.data) === null || _vm$milestoneInfo23$p4 === void 0 ? void 0 : _vm$milestoneInfo23$p4.mobile) + " ")]) : _vm._e()]], 2), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "26%",
      "overflow-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "margin-bottom:5px"
  }, [_c('strong', [_vm._v("Invoice No.")]), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("#" + _vm._s(_vm.invoiceId))])]), _c('br'), _c('div', {
    staticClass: "margin-bottom:5px"
  }, [_c('strong', [_vm._v("Invoice Date")]), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.issueDate))])]), _c('br'), _c('div', {
    staticClass: "margin-bottom:5px"
  }, [_c('strong', [_vm._v("Due Date")]), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.dueDate))])])]), _c('div', {
    staticStyle: {
      "width": "37%",
      "overflow-wrap": "break-word"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.companyName))]), _c('br'), _c('br'), _c('div', [_vm._v(_vm._s(_vm.officeAddress))]), _c('div', [_vm._v("Phone: " + _vm._s(_vm.officeMobile))]), _c('div', [_vm._v("Email: " + _vm._s(_vm.officeEmail))])])]), _c('table', {
    staticStyle: {
      "width": "100%",
      "border-collapse": "collapse",
      "margin-top": "20px"
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#f5f5f5",
      "border": "1px solid black"
    }
  }, [_c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "left",
      "border": "1px solid black",
      "font-size": "11px"
    }
  }, [_vm._v(" SL No. ")]), _c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "left",
      "width": "40%",
      "border": "1px solid black",
      "font-size": "11px"
    }
  }, [_vm._v(" Description ")]), _c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "left",
      "border": "1px solid black",
      "font-size": "11px"
    }
  }, [_vm._v(" Quantity ")]), _c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black",
      "font-size": "11px"
    }
  }, [_vm._v(" Unit Price (" + _vm._s(_vm.currency) + ") ")]), _c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black",
      "font-size": "11px"
    }
  }, [_vm._v(" Total (" + _vm._s(_vm.currency) + ") ")])])]), _c('tbody', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._l(_vm.invoiceData.items, function (item, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "border": "1px solid black"
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(index + 1))]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "border": "1px solid black"
      }
    }, [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(item.itemTitle))]), _c('p', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "text-truncate",
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "title": item.description
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v(_vm._s(item.description))])])]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "border": "1px solid black",
        "text-align": "center"
      }
    }, [_vm._v(" " + _vm._s(item.qty || 0) + " ")]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "text-align": "right",
        "border": "1px solid black"
      }
    }, [_vm._v(" " + _vm._s(item.cost || 0) + " ")]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "text-align": "right",
        "border": "1px solid black"
      }
    }, [_vm._v(" " + _vm._s(item.cost * item.qty || 0) + " ")])]);
  }), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Subtotal ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black"
    }
  }, [_vm._v(" " + _vm._s(_vm.subTotalAmount) + " ")])]), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" VAT ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black"
    }
  }, [_vm._v(" " + _vm._s(_vm.vatAmount) + " ")])]), _vm.showTax ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" TAX ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black"
    }
  }, [_vm._v(" " + _vm._s(_vm.taxAmount) + " ")])]) : _vm._e(), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Grand Total ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "color": "red",
      "border": "1px solid black"
    }
  }, [_c('strong', [_vm._v(_vm._s((_vm$grandTotalAmount3 = _vm.grandTotalAmount) !== null && _vm$grandTotalAmount3 !== void 0 ? _vm$grandTotalAmount3 : 0))])])])], 2)]), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "11px",
      "text-transform": "capitalize"
    }
  }, [_c('strong', [_vm._v("In Words: " + _vm._s(_vm.currency) + " " + _vm._s(_vm.numWords((_vm$grandTotalAmount4 = _vm.grandTotalAmount) !== null && _vm$grandTotalAmount4 !== void 0 ? _vm$grandTotalAmount4 : 0)) + " Only")])]), _vm.remarks ? _c('h4', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_c('strong', [_vm._v("Note/Terms")])]) : _vm._e(), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.remarks)
    }
  })]), _c('h2', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px",
      "margin-bottom": "50px"
    }
  }, [_vm._v(" Thank You For Your Business ")]), _c('br'), _vm.showLogo ? _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "text-align": "center",
      "display": "block",
      "position": "absolute",
      "bottom": "0",
      "left": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto",
      "width": "80%",
      "margin-bottom": "0.5rem"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "flex-wrap": "wrap"
    }
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#145BFF"
    }
  }, [_vm._v("M:")]), _vm._v(" " + _vm._s(_vm.officeMobile) + " ")]), _c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#145BFF"
    }
  }, [_vm._v("E:")]), _vm._v(" " + _vm._s(_vm.officeEmail) + " ")]), _c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#145BFF"
    }
  }, [_vm._v("W:")]), _vm._v(" " + _vm._s(_vm.officeWebsite) + " ")])]), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(" " + _vm._s(_vm.companyName) + ", " + _vm._s(_vm.officeAddress) + " ")])]), _c('div', {
    staticStyle: {
      "background-color": "#145BFF",
      "height": "30px",
      "width": "100%"
    }
  })]) : _vm._e()])]), _c('invoice-sidebar-send-invoice'), _c('invoice-sidebar-add-payment', {
    attrs: {
      "invoiceInfo": _vm.invoiceInfo,
      "milestoneInfo": _vm.milestoneInfo
    },
    on: {
      "loadInvoiceInfo": _vm.updateInvoiceInfo
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }